import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Label } from 'types';

type CreateLabelData = {
  name: string;
  color?: string;
  project?: string;
  org: string;
};

const createLabel = async (labelData: CreateLabelData): Promise<Label> => {
  const response = await customAxios.post<Label>('/labels', labelData);
  return response.data;
};

export const useCreateLabel = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createLabel,
    onSuccess: () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['labels', orgId] }).catch(() => undefined);
    },
  });
};
